// extracted by mini-css-extract-plugin
export default {"modal":"PlaneInfoModal_modal__IG3Ug"};